import React, { useContext, useEffect, useState } from 'react'
import img2 from '../Assets/Link → trend2.png.png';
import { CountryContext } from './CountryProvider';
import { Get_Api } from '../Api_Url';
import { useNavigate } from 'react-router-dom';

function DestinationinCountry() {
    const navigate = useNavigate();
    const { selectedCountry, setSelectedCountry, CountryName } = useContext(CountryContext);

    const [AllDestinationinCountry, setAllDestinationinCountry] = useState([]);
    const [IsUploading, setIsUploading] = useState(false);

    const GetAllDestinationinCountry = async () => {
        try {
            setIsUploading(true)
            const response = await Get_Api(`api/admin/GetAllCountrywiseDestinationInCountry/${selectedCountry}`)
            setAllDestinationinCountry(response?.data)
            setIsUploading(false)
        } catch (error) {
            setIsUploading(false)
            console.log(error)
        }
    }

    useEffect(() => {
        GetAllDestinationinCountry();
    }, [selectedCountry]);

    const OntoPage = (id) => {
        navigate(`/DestinationinCountryDetails/${id}`);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };


    if (IsUploading) {
        return (
            <div >
                Loading
            </div>
        )
    }

    return (
        <>
            <div className='pd-copy'>
                <div className='Destination'>
                    <h2>Destinations In {CountryName || "India"}</h2>
                </div>
                <div className='Destinationcards-container'>
                    {AllDestinationinCountry?.length > 0 ? (
                        AllDestinationinCountry.map((place, index) => (
                            <div onClick={()=>{OntoPage(place?._id)}} className="Destinationcard hover-effect" key={index}>
                                <img src={place?.Image || img2} alt={place?.name} className="Destinationcard-image" />
                                <div className="Destinationcard-title">
                                    {place?.Name}
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="no-destination">No destinations added</div>
                    )}
                </div>

            </div>
        </>
    )
}

export default DestinationinCountry